
import { Component, Prop, Vue } from 'vue-property-decorator'
import ColorContentUnitBox from '@/components/molecules/ColorContentUnitBox.vue'
import LearningProgressTip from '@/components/organisms/LearningProgressTip.vue'
import { LearningStatusCurriculumUnit } from '@/models/CurriculumUnit'

/**
 * 色付き単元情報項目ボックス
 */
@Component({
  components: {
    ColorContentUnitBox,
    LearningProgressTip,
  },
})
export default class ColorCurriculumUnitBox extends Vue {
  /** 学習状況付き単元情報 */
  @Prop()
  private learningStatusCurriculumUnit!: LearningStatusCurriculumUnit

  /** ボックスクリック時のイベント */
  @Prop()
  private eventClickBox!: (id: number) => void
}
